import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/header/index.js';
import './index.css';

import image1 from './assets/home/home1.png';
import image2 from './assets/home/home2.png';
import image3 from './assets/home/home3.png';

// Importação das páginas
import SedeSenado from './pages/sedeSenado';
import ConstrucaoInstalacao from './pages/ConstrucaoInstalacao';
import ParlamentoNovaCapital from './pages/parlamentoNovaCapital';
import Inauguracao from './pages/Inauguracao';
import OrigemEvolucaoForma from './pages/OrigemEvolucaoForma';
import PalacioCondeArcos from './pages/PalacioCondeArcos';
import PalacioMonroe from './pages/PalacioMonroe';
import Ambiental from './pages/ambiental';
import Ambiental2 from './pages/ambiental2';
import Terra from './pages/terra';
import Direitos from './pages/direitos';
import Documentarios from './pages/documentarios';
import Episodios from './pages/episodios';
import Constituicoes from './pages/constituicoes';
import Constituicao1824 from './pages/constituicao-1824';
import Constituicao1891 from './pages/constituicao-1891';
import Constituicao1934 from './pages/constituicao-1934';
import Constituicao1937 from './pages/constituicao-1937';
import Constituicao1946 from './pages/constituicao-1946';
import Constituicao1967 from './pages/constituicao-1967';
import Constituicao1988 from './pages/constituicao-1988';
import Religiao from './pages/religiao';
import Religiao2 from './pages/religiao2';
import Cultura from './pages/cultura';
import Cultura2 from './pages/cultura2';
import Legislativo from './pages/legislativo';
import RelacoesInternacionais from './pages/rel';
import Ditadura from './pages/ditadura';
import Militar from './pages/militar';
import Parlamento from './pages/parlamento';

function App() {
  const images = [image1, image2, image3];
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [currentTitleClass, setTitleClass] = useState('home-title');

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 20000); // Muda a imagem a cada 20 segundos *Altador para 700000 para verificar formatação*

    return () => clearInterval(interval);
  }, [images.length]);

  useEffect(() => {
    // Se for a terceira imagem (índice 2), muda a classe do título
    setTitleClass(currentImageIndex === 2 ? 'home-title-right' : 'home-title');
  }, [currentImageIndex]);

  const backgroundStyle = {
    backgroundImage: `url(${images[currentImageIndex]})`,
    height: '100vh',
    width: '100vw',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    transition: 'background-image 1s ease-in-out',
    fontFamily: 'futura',
  };

  const Home = () => (
    <div style={backgroundStyle}>
      <Header show={true} cor="preto" />
      <div className={currentTitleClass}>
        SENADO <span className="bold">200 ANOS</span>
      </div>
    </div>
  );

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/sedeSenado" element={<SedeSenado />} />
      <Route path="/ConstrucaoInstalacao" element={<ConstrucaoInstalacao />} />
      <Route path="/parlamentoNovaCapital" element={<ParlamentoNovaCapital />} />
      <Route path="/Inauguracao" element={<Inauguracao />} />
      <Route path="/OrigemEvolucaoForma" element={<OrigemEvolucaoForma />} />
      <Route path="/PalacioCondeArcos" element={<PalacioCondeArcos />} />
      <Route path="/PalacioMonroe" element={<PalacioMonroe />} />
      <Route path="/ambiental" element={<Ambiental />} />
      <Route path="/ambiental/2" element={<Ambiental2 />} />
      <Route path="/terra-e-poder" element={<Terra />} />
      <Route path="/direitos" element={<Direitos />} />
      <Route path="/documentarios" element={<Documentarios />} />
      <Route path="/episodios/:ep" element={<Episodios />} />
      <Route path="/constituicoes" element={<Constituicoes />} />
      <Route path="/constituicoes/1824/:secaoId" element={<Constituicao1824 />} />
      <Route path="/constituicoes/1824" element={<Constituicao1824 />} />
      <Route path="/constituicoes/1891" element={<Constituicao1891 />} />
      <Route path="/constituicoes/1934" element={<Constituicao1934 />} />
      <Route path="/constituicoes/1937" element={<Constituicao1937 />} />
      <Route path="/constituicoes/1946" element={<Constituicao1946 />} />
      <Route path="/constituicoes/1967" element={<Constituicao1967 />} />
      <Route path="/constituicoes/1988" element={<Constituicao1988 />} />
      <Route path="/religiao" element={<Religiao />} />
      <Route path="/religiao2" element={<Religiao2 />} />
      <Route path="/cultura" element={<Cultura />} />
      <Route path="/cultura2" element={<Cultura2 />} />
      <Route path="/legislativo" element={<Legislativo />} />
      <Route path="/rel" element={<RelacoesInternacionais />} />
      <Route path="ditadura" element={<Ditadura />} />
      <Route path="/militar" element={<Militar />} />
      <Route path="/parlamento" element={<Parlamento />} />
      
    </Routes>
  );
}

export default App;
